<div class="container mx-auto p-4 max-w-5xl">
  <div class="daisy-breadcrumbs mb-4 text-sm">
    <ul>
      <li>
        <a href="/dashboard/user#invoices" class="text-primary">Invoices</a>
      </li>
      <li class="text-gray-500">Preview</li>
    </ul>
  </div>

  <!-- Loading Skeleton -->
  @if (isLoading) {
    <div class="daisy-card bg-base-100 shadow-lg">
      <div class="daisy-card-body">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div class="daisy-skeleton h-8 w-48 mb-4"></div>
            <div class="space-y-3">
              <div class="daisy-skeleton h-4 w-full"></div>
              <div class="daisy-skeleton h-4 w-full"></div>
              <div class="daisy-skeleton h-4 w-full"></div>
              <div class="daisy-skeleton h-4 w-full"></div>
            </div>
          </div>
          <div>
            <div class="daisy-skeleton h-8 w-48 mb-4"></div>
            <div class="space-y-3">
              <div class="daisy-skeleton h-4 w-full"></div>
              <div class="daisy-skeleton h-4 w-full"></div>
            </div>
          </div>
        </div>
        <div class="daisy-divider"></div>
        <div>
          <div class="daisy-skeleton h-8 w-48 mb-4"></div>
          <div class="space-y-3">
            <div class="daisy-skeleton h-4 w-full"></div>
            <div class="daisy-skeleton h-4 w-full"></div>
            <div class="daisy-skeleton h-4 w-full"></div>
          </div>
        </div>
        <div class="daisy-card-actions justify-end mt-6">
          <div class="daisy-skeleton h-10 w-40"></div>
        </div>
      </div>
    </div>
  }

  <!-- Invoice Content -->
  @if (!isLoading && invoice) {
    <div class="daisy-card bg-base-100 shadow-lg">
      <div class="daisy-card-body">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 class="text-xl font-bold mb-4">Invoice Details</h3>
            <div class="table-container w-full">
              <table class="daisy-table table-zebra w-full">
                <tbody>
                  <tr>
                    <td class="font-medium">Invoice Number:</td>
                    <td>{{ invoice.invoiceNumber }}</td>
                  </tr>
                  <tr>
                    <td class="font-medium">Created On:</td>
                    <td>{{ invoice.createdOn | date }}</td>
                  </tr>
                  <tr>
                    <td class="font-medium">Due Date:</td>
                    <td>{{ invoice.dueDate | date }}</td>
                  </tr>
                  <tr>
                    <td class="font-medium">Status:</td>
                    <td>
                      <span class="daisy-badge badge-primary">{{
                        invoice.status
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <h3 class="text-xl font-bold mb-4">Payment Details</h3>
            <div class="table-container w-full">
              <table class="daisy-table table-zebra w-full">
                <tbody>
                  <tr>
                    <td class="font-medium">Total Amount:</td>
                    <td>{{ invoice.amount }} {{ invoice.currency }}</td>
                  </tr>
                  <tr>
                    <td class="font-medium">Amount Payable:</td>
                    <td>
                      {{ calculatePayable(invoice.amount, invoice.payments) }}
                      {{ invoice.currency }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="daisy-divider"></div>
        <div class="mt-6">
          <h3 class="text-xl font-bold mb-4">Payment History</h3>
          <div class="overflow-x-auto">
            <table class="daisy-table table-zebra w-full">
              <thead>
                <tr>
                  <th>Paid On</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Attachments</th>
                </tr>
              </thead>
              <tbody>
                @for (payment of invoice.payments; track payment) {
                  <tr>
                    <td>{{ payment.initiatedOn | date }}</td>
                    <td>{{ payment.amount }} {{ invoice.currency }}</td>
                    <td>
                      <span
                        class="daisy-badge"
                    [ngClass]="
                      payment.isApproved ? 'badge-success' : 'badge-warning'
                    "
                        >
                        {{ payment.isApproved ? 'APPROVED' : 'PROCESSING' }}
                      </span>
                    </td>
                    <td>
                      @if (payment.bankData?.slip) {
                        <button
                          class="daisy-btn btn-sm btn-outline"
                    (click)="
                      downloadFile(
                        payment.bankData?.slip?.path,
                        payment.bankData?.slip?.name
                      )
                    "
                          >
                          <i class="fa-regular fa-circle-down mr-2"></i> Download
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        <div class="daisy-card-actions justify-end mt-6 space-x-2">
          @if (isInvoicePayable(invoice.status)) {
            <button
              class="daisy-btn daisy-btn-success"
              (click)="payInvoice(invoice._id)"
              >
              <i class="fa-regular fa-credit-card mr-2"></i> Pay Now
            </button>
          }
          <button
            class="daisy-btn daisy-btn-primary"
            (click)="downloadInvoice()"
            [disabled]="isDownloading"
            >
            <i
              class="fa-regular"
              [ngClass]="isDownloading ? 'fa-spinner fa-spin' : 'fa-file-pdf'"
            ></i>
            {{ isDownloading ? 'Downloading...' : 'Download Invoice PDF' }}
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Error State -->
  @if (!isLoading && error) {
    <div class="daisy-alert alert-warning mt-4">
      <div>
        <i class="fa-regular fa-triangle-exclamation mr-2"></i>
        <span>
          <h3 class="font-bold">Invoice Not Found</h3>
          <div class="text-xs">The requested invoice could not be found.</div>
        </span>
      </div>
    </div>
  }
</div>
